@if (this.loanTypes) {
  <svg class="skyline" viewBox="0 0 1440 340" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
    <path fill="currentColor" d="M0 340V220h40v-60h30v60h50V120h20V80h15v40h20v100h60V190h50v150h40V160h35v-40h20v40h35v180h70V200h55v-70h25v70h50v140h60V150h45v190h50V230h60v-40h25v40h55v110h70V180h40v-60h20v60h45v160h60V210h50v130h55V170h30v-30h18v30h32v200z"></path>
  </svg>
  <div class="layout-fluid-constrained layout-align-center">
    <div class="loan-sliders-info-wrapper">
      <div class="info-text-col">
        <h1>Бързи кредити онлайн от <span>MiniZaem.bg</span></h1>
        <p>Кандидатствайте онлайн за бърз кредит с ясни условия, прозрачен ГПР и удобен процес изцяло от разстояние. Изберете сума и срок чрез калкулатора, попълнете онлайн заявка и получете отговор след разглеждане на кандидатурата.</p>
        <button class="cta" (click)="startApplication()">Вземи сега</button>
        <div class="note">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#8fc043" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6z"></path>
            <polyline points="8.5 12 11 14.5 15.5 9.5"></polyline>
          </svg>
          <span>Всички разходи са включени в ГПР. MiniZaem.bg предлага кредити без скрити такси и с възможност за предсрочно погасяване без такси и неустойки.</span>
        </div>
      </div>
      <div class="sliders-col" id="calculator">
        <div class="sliders">
          <ul class="loan-types">
            @for (loanType of this.loanTypes; track $index) {
              <li>
                <a href="javascript:;" [ngClass]="loanType.id == this.selectedLoanType?.id? 'active': ''" (click)="changeSelectedLoanType(loanType.id)">
                  {{ getTranslation(loanType).name }} до
                  <span>{{ loanType.principalMaximum }} € </span>
                  <span class="value-secondary-currency">({{ this.currencyService.convertAmount(loanType.principalMaximum) }})</span>
                </a>
              </li>
            }
          </ul>
          <div class="slider-title principal">
            <span class="title">Избери сума</span>
            <span class="limit">до
          <span class="value">{{ selectedLoanType?.principalMaximum }}</span> €
          <span class="value-secondary-currency">({{ this.currencyService.convertAmount(selectedLoanType?.principalMaximum ?? 0) }})</span>
        </span>
          </div>
          <div class="loan-slider-wrapper principal">
            @if (selectedLoanType) {
              <mat-slider
                class="loan-slider"
                min="{{selectedLoanType.principalMinimum}}"
                max="{{selectedLoanType.principalMaximum}}"
                step="{{selectedLoanType.principalOffsetSize}}"
                (change)="executeApiCalculations()"
              >
                <input type="range" matSliderThumb [(ngModel)]="selectedPrincipal" #principalSlider>
              </mat-slider>

              <div class="value-wrapper">
                <span class="value">{{ selectedPrincipal }}  € </span>
                <span class="value-secondary-currency">({{ this.currencyService.convertAmount(selectedPrincipal) }})</span>
              </div>
            }
          </div>
          <div class="slider-title period hidden">
            <span class="title">Избери период</span>
            <span class="limit">до <span class="value">{{ selectedLoanType?.periodMaximum }}</span> дни
				</span>
            <!--        @if (selectedLoanType?.constant == "EVEN_PRINCIPAL_PAYMENTS") {-->
            <!--          <app-pop-over>За суми до {{ selectedPrincipal }} лв. максималният срок на изплащане е {{ calculatePeriodMaximum() }} месеца.</app-pop-over>-->
            <!--        }-->
          </div>
          <div class="loan-slider-wrapper period hidden">
            @if (selectedLoanType) {
              <mat-slider
                class="loan-slider"
                min="{{selectedLoanType.periodMinimum}}"
                max="{{selectedLoanType.periodMaximum}}"
                step="{{selectedLoanType.periodOffsetSize}}"
              >
                <input type="range" matSliderThumb [(ngModel)]="selectedPeriod" #periodSlider>
              </mat-slider>
              <div class="value-wrapper"><span class="value"></span>
                <span>{{ selectedPeriod }} дни</span>
              </div>
            }
          </div>
        </div>
        <div class="parameters-wrapper">
          <app-loader [isLoading]="areApiCalculationsLoading"></app-loader>
          <div class="parameter principal">
            <div class="label">Взимате</div>
            <div class="value">
              <span class="principal">{{ selectedPrincipal }}</span> €
              <span class="value-secondary-currency">&nbsp;({{ this.currencyService.convertAmount(selectedPrincipal) }})</span>
            </div>
          </div>

          <div class="parameter">
            <div class="label">Връщате</div>
            <div class="value">
              <span class="repayment-amount-total">{{ loanAggregatedAmounts?.totalAmountDue.toFixed(2) }} € </span>
              <span class="value-secondary-currency">&nbsp;({{ this.currencyService.convertAmount(loanAggregatedAmounts?.totalAmountDue.toFixed(2)) }})</span>
            </div>
          </div>

          <div class="parameter">
            <div class="label">Взимате</div>
            <div class="value"><span class="principal">{{ selectedPeriod }}</span> дни</div>
          </div>

          <div class="parameter">
            <div class="label">Вноски</div>
            <div class="value">
              <span class="payments-count">{{ getSelectedPeriodLoanInstalmentsCount() }}</span>
              бр.
            </div>
          </div>

          <div class="parameter">
            <div class="label">ГПР</div>
            <div class="value">
              <span class="apr">{{ loanAggregatedAmounts.annualPercentageRate }} %</span>
            </div>
          </div>

          <!--      <div class="parameter">-->
          <!--        @if (selectedLoanType?.constant == "EVEN_PRINCIPAL_PAYMENTS") {-->
          <!--          <app-pop-over pointerTitle="Виж погасителен план" popOverWidth="230">-->
          <!--            <div class="repayment-plan-panel">-->
          <!--              <div class="payment-wrapper">-->
          <!--                <div class="number"></div>-->
          <!--                <div class="due-date">Дата</div>-->
          <!--                <div class="amount">Сума</div>-->
          <!--              </div>-->
          <!--              @for (loanInstalment of this.getLoanInstalments(); track $index) {-->
          <!--                <div class="payment-wrapper">-->
          <!--                  <div class="number">{{ $index + 1 }}.</div>-->
          <!--                  <div class="due-date">{{ loanInstalment.maturityDate }}</div>-->
          <!--                  <div class="amount">{{ loanInstalment.amount }} лв.</div>-->
          <!--                </div>-->
          <!--              }-->
          <!--            </div>-->
          <!--          </app-pop-over>-->
          <!--        }-->
          <!--      </div>-->
          <button (click)="startApplication()">Вземи сега</button>
        </div>
      </div>
    </div>
  </div>
}
